import React, { useState } from 'react';
import { Dialog, Table, TableRow  } from '@material-ui/core';
import { CoreIcon } from '@clover/web-lib-core/components';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { useFetchAppVersionsQuery } from '../../../../redux/api/appMarket-api-slice';
import { AndroidVersion, App } from '../../../../models/app';
import moment from 'moment-timezone';
import { ListWithLoadMore } from '../../../Common/ListWithLoadMore';
import { BackgroundShimmer } from 'components/Shimmer';

interface ComponentProps {
  onClose: () => void;
  app: App;
}

const ENTRIES_PER_PAGE = 15;
export const VersionHistoryModal = (props: ComponentProps): JSX.Element => {
  const { onClose, app } = props;
  const [t, i18n] = useTranslation();
  const [limit, setLimit] = useState<number>(ENTRIES_PER_PAGE + 1);
  const { data: appVersions, isLoading, isFetching } = useFetchAppVersionsQuery({
    id: app.id,
    limit,
  });
  const handleClose = () => {
    onClose();
  };
  const changeLimit = (apiLimit: number) => {
    if (apiLimit !== limit) setLimit(apiLimit);
  };

  const renderVersionItem = (androidVersion: Maybe<AndroidVersion>): JSX.Element => {
    const releaseNote = androidVersion?.releaseNote?.note;
    return (
      <div className={styles.versionSpacing}>
        <TableRow key={androidVersion?.id}>
          <p style={{margin:'0' }}>
            {t('version', { versionName: androidVersion?.versionName }) +
            ' ' +
            t('submitted_at', {
              dateString: androidVersion?.submittedAt
                ? moment(androidVersion?.submittedAt)
                  ?.locale(i18n.language)
                  .format('MM-DD-YYYY')
                : moment(androidVersion?.createdAt)
                  ?.locale(i18n.language)
                  .format('MM-DD-YYYY'),
            })}
          </p>
        </TableRow>
        {releaseNote && <p className='secondaryText' style={{ color: '#5C5C5C', margin:'0' }}>
          {releaseNote}
        </p>}
      </div>
    );
  };

  return (
    <Dialog
      onClose={handleClose}
      open={true}
      maxWidth={false}
      PaperProps={{ classes: { root: styles.versionHistory } }}
    >
      <CoreIcon
        className={styles.closeIcon}
        onClick={handleClose}
        glyph='close'
        height={14}
        width={14}
        role='application'
		data-testid='closeVersionHistoryModal'
      />
      <div className={styles.modalContent}>
        <h4 style={{ color: '#000000',marginBottom:'10px' }}>{t('app_details.release_update', { appName: app.name })}</h4>
        <Table className='app-version-history-page'>
          <ListWithLoadMore<AndroidVersion>
            config={{
              maxEntriesPerPage: ENTRIES_PER_PAGE,
              maxLimit: 60,
            }}
            isLoading={isLoading}
            isFetching={isFetching}
            items={appVersions}
            setApiLimit={changeLimit}
            renderItem={renderVersionItem}
            renderInitialLoader={() => <BackgroundShimmer smallShimmer={false} />}
            loaderLength={1}
          />
        </Table>
      </div>
    </Dialog>
  );
};
